/**
 * Configuraciones por país - Sistema dinámico
 * Cada país tiene su propia configuración de documentos, regímenes, monedas, etc.
 */

const countrySettings = {
  // ESPAÑA
  "ES": {
    country: {
      code: "ES",
      name: "España",
      currency: "EUR",
      locale: "es-ES",
      currencySymbol: "€",
      simplifiedInvoiceLimit: 100,
      requiresFullInvoiceLimit: 400
    },
    invoice_types: [
      {
        value: "TK",
        label: "Ticket (Sin valor fiscal)",
        description: "Comprobante de venta sin valor fiscal"
      },
      {
        value: "FS",
        label: "Factura Simplificada",
        description: "Hasta 400€ - Datos básicos del cliente"
      },
      {
        value: "FC",
        label: "Factura Completa",
        description: "Datos completos - Deducible IVA"
      }
    ],
    type_liabilities: [
      {
        "id": "1",
        "name": "Contribuyente IVA",
        "code": "ES-01",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Régimen Simplificado",
        "code": "ES-02",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Régimen de Módulos",
        "code": "ES-03",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "No sujeto a IVA",
        "code": "ES-04",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "5",
        "name": "Régimen Especial Agrario",
        "code": "ES-05",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_organizations: [
      {
        "id": "1",
        "name": "Sociedad",
        "code": "ES-S",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Autónomo",
        "code": "ES-A",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Cooperativa",
        "code": "ES-C",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_regimes: [
      {
        "id": "1",
        "name": "Régimen General",
        "code": "ES-G",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Régimen Especial Simplificado",
        "code": "ES-S",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Régimen Especial de Recargo de Equivalencia",
        "code": "ES-R",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "Exento de IVA",
        "code": "ES-E",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "5",
        "name": "Régimen Especial de Bienes Usados",
        "code": "ES-B",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_document_identifications: [
      {
        "id": "1",
        "name": "DNI",
        "scope": null,
        "code": "DNI",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "NIE",
        "scope": null,
        "code": "NIE",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "NIF",
        "scope": null,
        "code": "NIF",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "CIF",
        "scope": null,
        "code": "CIF",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "5",
        "name": "Pasaporte",
        "scope": null,
        "code": "PAS",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    departments: [
      {
        "id": "1",
        "name": "Andalucía",
        "code": "01",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Aragón",
        "code": "02",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Asturias, Principado de",
        "code": "03",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "Balears, Illes",
        "code": "04",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "5",
        "name": "Canarias",
        "code": "05",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "6",
        "name": "Cantabria",
        "code": "06",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "7",
        "name": "Castilla-La Mancha",
        "code": "07",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "8",
        "name": "Castilla y León",
        "code": "08",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "9",
        "name": "Cataluña",
        "code": "09",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "10",
        "name": "Comunitat Valenciana",
        "code": "10",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "11",
        "name": "Extremadura",
        "code": "11",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "12",
        "name": "Galicia",
        "code": "12",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "13",
        "name": "Madrid, Comunidad de",
        "code": "13",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "14",
        "name": "Murcia, Región de",
        "code": "14",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "15",
        "name": "Navarra, Comunidad Foral de",
        "code": "15",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "16",
        "name": "País Vasco",
        "code": "16",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "17",
        "name": "Rioja, La",
        "code": "17",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "18",
        "name": "Ceuta",
        "code": "18",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "19",
        "name": "Melilla",
        "code": "19",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    vat_rates: [
      {
        "id": "1",
        "name": "General",
        "code": "IVA-21",
        "rate": 21,
        "description": "Tipo general de IVA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Reducido",
        "code": "IVA-10",
        "rate": 10,
        "description": "Tipo reducido para alimentos, transporte, etc.",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Superreducido",
        "code": "IVA-4",
        "rate": 4,
        "description": "Tipo superreducido para productos básicos",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "Exento",
        "code": "IVA-0",
        "rate": 0,
        "description": "Operaciones exentas de IVA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ]
  },

  // COLOMBIA
  "CO": {
    country: {
      code: "CO",
      name: "Colombia",
      currency: "COP",
      locale: "es-CO",
      currencySymbol: "$",
      simplifiedInvoiceLimit: 100000,
      requiresFullInvoiceLimit: 500000
    },
    invoice_types: [
      {
        value: "FE",
        label: "Factura Electrónica",
        description: "Documento fiscal electrónico - Única opción en Colombia"
      }
    ],
    type_liabilities: [
      {
        "id": "5",
        "name": "Gran contribuyente",
        "code": "O-13",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "7",
        "name": "Autorretenedor",
        "code": "O-15",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "12",
        "name": "Agente de retención IVA",
        "code": "O-23",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
            {
        "id": "20",
        "name": "Régimen simple de tributación",
        "code": "O-47",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "29",
        "name": "No aplica – Otros",
        "code": "R-99-PN",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
     
    ],
    type_organizations: [
      {
        "id": "1",
        "name": "Persona Jurídica",
        "code": "1",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Persona Natural",
        "code": "2",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_regimes: [
      {
        "id": "1",
        "name": "Impuesto sobre las ventas – IVA",
        "code": "48",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "No responsable de IVA",
        "code": "49",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_document_identifications: [
      {
        "id": "1",
        "name": "Cédula de Ciudadanía",
        "scope": null,
        "code": "CC",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Cédula de Extranjería",
        "scope": null,
        "code": "CE",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "NIT",
        "scope": null,
        "code": "NIT",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "Tarjeta de Identidad",
        "scope": null,
        "code": "TI",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "5",
        "name": "Pasaporte",
        "scope": null,
        "code": "PA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "6",
        "name": "NUIP",
        "scope": null,
        "code": "NUIP",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    departments: [
      {
        "id": "1",
        "name": "Amazonas",
        "code": "91",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Antioquia",
        "code": "05",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Arauca",
        "code": "81",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "Atlántico",
        "code": "08",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "5",
        "name": "Bogotá D.C.",
        "code": "11",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "6",
        "name": "Bolívar",
        "code": "13",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "7",
        "name": "Boyacá",
        "code": "15",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "8",
        "name": "Caldas",
        "code": "17",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "9",
        "name": "Caquetá",
        "code": "18",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "10",
        "name": "Casanare",
        "code": "85",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "11",
        "name": "Cauca",
        "code": "19",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "12",
        "name": "Cesar",
        "code": "20",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "13",
        "name": "Chocó",
        "code": "27",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "14",
        "name": "Córdoba",
        "code": "23",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "15",
        "name": "Cundinamarca",
        "code": "25",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "16",
        "name": "Guainía",
        "code": "94",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "17",
        "name": "Guaviare",
        "code": "95",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "18",
        "name": "Huila",
        "code": "41",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "19",
        "name": "La Guajira",
        "code": "44",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "20",
        "name": "Magdalena",
        "code": "47",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "21",
        "name": "Meta",
        "code": "50",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "22",
        "name": "Nariño",
        "code": "52",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "23",
        "name": "Norte de Santander",
        "code": "54",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "24",
        "name": "Putumayo",
        "code": "86",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "25",
        "name": "Quindío",
        "code": "63",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "26",
        "name": "Risaralda",
        "code": "66",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "27",
        "name": "San Andrés y Providencia",
        "code": "88",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "28",
        "name": "Santander",
        "code": "68",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "29",
        "name": "Sucre",
        "code": "70",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "30",
        "name": "Tolima",
        "code": "73",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "31",
        "name": "Valle del Cauca",
        "code": "76",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "32",
        "name": "Vaupés",
        "code": "97",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "33",
        "name": "Vichada",
        "code": "99",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    municipalities: [
      {
        "id": "11001",
        "name": "Bogotá D.C.",
        "code": "11001",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "05001",
        "name": "Medellín",
        "code": "05001",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "76001",
        "name": "Cali",
        "code": "76001",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "08001",
        "name": "Barranquilla",
        "code": "08001",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "13001",
        "name": "Cartagena",
        "code": "13001",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    vat_rates: [
      {
        "id": "1",
        "name": "General",
        "code": "IVA-19",
        "rate": 19,
        "description": "Tarifa general de IVA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Reducida",
        "code": "IVA-5",
        "rate": 5,
        "description": "Tarifa reducida para productos básicos",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Exento",
        "code": "IVA-0",
        "rate": 0,
        "description": "Operaciones exentas de IVA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ]
  },

  // MÉXICO  
  "MX": {
    country: {
      code: "MX",
      name: "México",
      currency: "MXN",
      locale: "es-MX"
    },
    type_liabilities: [
      {
        "id": "1",
        "name": "Persona Física con Actividad Empresarial",
        "code": "MX-01",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Persona Moral",
        "code": "MX-02",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Régimen de Incorporación Fiscal",
        "code": "MX-03",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_organizations: [
      {
        "id": "1",
        "name": "Persona Física",
        "code": "MX-PF",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Persona Moral",
        "code": "MX-PM",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_regimes: [
      {
        "id": "1",
        "name": "General de Ley",
        "code": "MX-GL",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Régimen de Incorporación Fiscal",
        "code": "MX-RIF",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    type_document_identifications: [
      {
        "id": "1",
        "name": "RFC",
        "scope": null,
        "code": "RFC",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "CURP",
        "scope": null,
        "code": "CURP",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Pasaporte",
        "scope": null,
        "code": "PA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    departments: [
      {
        "id": "1",
        "name": "Aguascalientes",
        "code": "AG",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Baja California",
        "code": "BC",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Baja California Sur",
        "code": "BS",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "4",
        "name": "Campeche",
        "code": "CM",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "5",
        "name": "Chiapas",
        "code": "CS",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "6",
        "name": "Chihuahua",
        "code": "CH",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "7",
        "name": "Ciudad de México",
        "code": "DF",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "8",
        "name": "Coahuila",
        "code": "CL",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "9",
        "name": "Colima",
        "code": "CM",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "10",
        "name": "Durango",
        "code": "DG",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "11",
        "name": "Guanajuato",
        "code": "GT",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "12",
        "name": "Guerrero",
        "code": "GR",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "13",
        "name": "Hidalgo",
        "code": "HG",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "14",
        "name": "Jalisco",
        "code": "JC",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "15",
        "name": "México",
        "code": "MC",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "16",
        "name": "Michoacán",
        "code": "MN",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "17",
        "name": "Morelos",
        "code": "MS",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "18",
        "name": "Nayarit",
        "code": "NT",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "19",
        "name": "Nuevo León",
        "code": "NL",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "20",
        "name": "Oaxaca",
        "code": "OC",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "21",
        "name": "Puebla",
        "code": "PL",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "22",
        "name": "Querétaro",
        "code": "QT",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "23",
        "name": "Quintana Roo",
        "code": "QR",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "24",
        "name": "San Luis Potosí",
        "code": "SP",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "25",
        "name": "Sinaloa",
        "code": "SL",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "26",
        "name": "Sonora",
        "code": "SR",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "27",
        "name": "Tabasco",
        "code": "TC",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "28",
        "name": "Tamaulipas",
        "code": "TS",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "29",
        "name": "Tlaxcala",
        "code": "TL",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "30",
        "name": "Veracruz",
        "code": "VZ",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "31",
        "name": "Yucatán",
        "code": "YN",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "32",
        "name": "Zacatecas",
        "code": "ZS",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ],
    vat_rates: [
      {
        "id": "1",
        "name": "General",
        "code": "IVA-16",
        "rate": 16,
        "description": "Tasa general de IVA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "2",
        "name": "Frontera",
        "code": "IVA-8",
        "rate": 8,
        "description": "Tasa fronteriza de IVA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      },
      {
        "id": "3",
        "name": "Exento",
        "code": "IVA-0",
        "rate": 0,
        "description": "Operaciones exentas de IVA",
        "deleted_at": null,
        "created_at": "2025-06-19T17:39:00.000000Z",
        "updated_at": "2025-06-19T17:39:00.000000Z"
      }
    ]
  }
};

// Configuraciones comunes a todos los países
const commonSettings = {
  type_environments: [
    {
      "tableName": "type_environments",
      "id": "1",
      "code": "1",
      "name": "Producción",
      "description": null,
      "deleted_at": "",
      "created_at": "2025-06-19T17:39:00.000000Z",
      "updated_at": "2025-06-19T17:39:00.000000Z",
      "scope": null,
      "cufe_algorithm": null,
      "type": null,
      "prefix": null
    },
    {
      "tableName": "type_environments",
      "id": "2",
      "code": "2",
      "name": "Pruebas",
      "description": null,
      "deleted_at": "",
      "created_at": "2025-06-19T17:39:00.000000Z",
      "updated_at": "2025-06-19T17:39:00.000000Z",
      "scope": null,
      "cufe_algorithm": null,
      "type": null,
      "prefix": null
    }
  ]
};

/**
 * Función principal que devuelve settings dinámicos según el país
 * @param {object} data - Datos adicionales a mergear
 * @returns {object} Configuraciones específicas del país
 */
export default (data = {}) => {
  // Esta versión está configurada exclusivamente para Colombia
  console.log(`🌍 Settings: Sistema configurado exclusivamente para Colombia (CO)`);
  
  // Usar configuración de Colombia
  const countryConfig = countrySettings['CO'];

  // Mergear configuración del país con settings comunes y data adicional
  return {
    ...countryConfig,
    ...commonSettings,
    ...data
  };
};

/**
 * Obtiene configuración específica de un país
 * @param {string} countryCode - Código de país
 * @returns {object} Configuración del país
 */
export const getCountrySettings = () => {
    // Esta versión está configurada exclusivamente para Colombia
    return countrySettings['CO'];
};

/**
 * Obtiene lista de países disponibles
 * @returns {array} Lista de países configurados
 */
export const getAvailableCountries = () => {
    // Esta versión está configurada exclusivamente para Colombia
    return [{
        code: 'CO',
        name: 'Colombia',
        currency: 'COP',
        locale: 'es-CO'
    }];
};

/**
 * Verifica si un país está configurado
 * @param {string} countryCode - Código de país
 * @returns {boolean} True si el país está configurado
 */
export const isCountrySupported = (countryCode) => {
    // Esta versión está configurada exclusivamente para Colombia
    return countryCode === 'CO';
};
